export default __webpack_public_path__ + "static/media/eyewhite.da4cc1e6.svg";